<!-- <div class="relative"> -->


<aside [ngClass]="{'-ml-64': !sidebarOpen, 'ml-0': sidebarOpen}" id="sidebar"
    class="fixed z-50 top-0 pb-3 px-6 w-64 flex flex-col justify-between h-screen border-r bg-[#232020] transition-all duration-800 ease-in-out">

    <!-- Toggle Button -->
    <button (click)="toggleSidebar()" class="absolute -right-16 top-3 z-20 p-2 text-orange-500 focus:outline-none">
     <svg class="h-6 w-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
         stroke-linejoin="round">
         <path d="M4 6h16M4 12h16m-7 6h7" />
     </svg>  
 </button>


    <div>


        <div class="px-8 py-4">
            <a href="#" title="home">
                <img src="/assets/images/surplustek-white-logo.png" class="w-40 m-auto" alt="POC WCS">
            </a>
        </div>


        <ul class="space-y-2 tracking-wide my-4 overflow-y-auto scrollbar-hide max-h-96">
            <li class="mb-3">
                <a href="#" [routerLink]="['/register-bulk-upload']" routerLinkActive="bg-orange-500 text-white font-medium"
                    class="px-5 py-3 flex items-center space-x-4 rounded-lg text-white group text-sm">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1.5rem" height="1.5rem" viewBox="0 0 24 24"
                        class="group-hover:text-orange-500 text-white" routerLinkActive="group-hover:text-white">
                        <path fill="currentColor" fill-rule="evenodd"
                            d="M9 4a4 4 0 1 0 0 8a4 4 0 0 0 0-8m-2 9a4 4 0 0 0-4 4v1a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-1a4 4 0 0 0-4-4zm8-1a1 1 0 0 1 1-1h1v-1a1 1 0 1 1 2 0v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 0 1-1-1"
                            clip-rule="evenodd" />
                    </svg>
                    <span class="text-white group-hover:text-orange-500"
                        routerLinkActive="group-hover:text-white">Bulk Upload Register</span>
                </a>
            </li>

            <!-- <li class="mb-3">
                <a  [routerLink]="['/my-profile']" routerLinkActive="bg-orange-500 text-white font-medium"
                    class="px-5 py-3 flex items-center space-x-4 rounded-lg text-white group text-sm">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1.5rem" height="1.5rem" viewBox="0 0 24 24"
                        class="group-hover:text-orange-500 text-white" routerLinkActive="group-hover:text-white">
                        <path fill="currentColor" fill-rule="evenodd"
                            d="M12 4a4 4 0 1 0 0 8a4 4 0 0 0 0-8m-2 9a4 4 0 0 0-4 4v1a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-1a4 4 0 0 0-4-4z"
                            clip-rule="evenodd" />
                    </svg>
                    <span class="text-white group-hover:text-orange-500" routerLinkActive="group-hover:text-white">My
                        Profile</span>
                </a>
            </li> -->

            <li class="mb-3">
                <a [routerLink]="['/change-password']" routerLinkActive="bg-orange-500 text-white font-medium"
                    class="px-5 py-3 flex items-center space-x-4 rounded-lg text-white group text-sm">
                    <svg xmlns="http://www.w3.org/2000/svg" width="1.5rem" height="1.5rem" viewBox="0 0 24 24"
                        class="group-hover:text-orange-500 text-white" routerLinkActive="group-hover:text-white" s>
                        <path fill="currentColor" d="M12 9.75a2.25 2.25 0 1 0 0 4.5a2.25 2.25 0 0 0 0-4.5" />
                        <path fill="currentColor" fill-rule="evenodd"
                            d="M12 5.5c-2.618 0-4.972 1.051-6.668 2.353c-.85.652-1.547 1.376-2.036 2.08c-.48.692-.796 1.418-.796 2.067s.317 1.375.796 2.066c.49.705 1.186 1.429 2.036 2.08C7.028 17.45 9.382 18.5 12 18.5s4.972-1.051 6.668-2.353c.85-.652 1.547-1.376 2.035-2.08c.48-.692.797-1.418.797-2.067s-.317-1.375-.797-2.066c-.488-.705-1.185-1.429-2.035-2.08C16.972 6.55 14.618 5.5 12 5.5M8.25 12a3.75 3.75 0 1 1 7.5 0a3.75 3.75 0 0 1-7.5 0"
                            clip-rule="evenodd" />
                    </svg>
                    <span class="text-white group-hover:text-orange-500"
                        routerLinkActive="group-hover:text-white">Change password</span>
                </a>
            </li>

        </ul>
    </div>

    <div class="border-t border-gray-200"></div>
    <div class="px-2 mx-10 my-5 py-2 flex justify-center items-center border">
        <button (click)="logout()" class="flex items-center space-x-4 rounded-md text-white group">
            <svg class="h-6 w-6 text-white" width="24" height="24" viewBox="0 0 24 24" stroke-width="2"
                stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" />
                <path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2" />
                <path d="M20 12h-13l3 -3m0 6l-3 -3" />
            </svg>
            <span class="group-hover:text-white focus:outline-none">Logout</span>
        </button>
    </div>
</aside>
<!-- </div> -->